module.exports = __webpack_public_path__ + "img/high-book.ae4c7c84.png";